import React from 'react'
import Image from 'next/image'
import { GoArrowUpRight } from 'react-icons/go';
import Link from 'next/link';
import ClientsCount from '@/components/CommonComponent/ClientsCount';

const Revenue = ({props ,cards}:any) => {
  // console.log('props are ',props)
  return (
    <div className='w-full py-10 md:py-16  text-white bg_rev'>
      <div className='w-full xl:w-[95%]  2xl:w-[80%] text-center lg:text-left text-white mx-auto px-4'>
        <h2 className=' mt-4 font-bold '>{props.title}</h2>
        <div className='  text-[16px] lg:text-[18px]' dangerouslySetInnerHTML={{__html:props.description}}/>
        <div className='w-full mt-12 flex justify-center lg:justify-start gap-4 lg:flex-nowrap flex-wrap  '>
          {
          cards?.map((Element:any ,index:number)=>
              <div className=' w-[97%] sm:w-[307px] h-[164px] flex bg-white text-white bg-white/10 px-6  rounded-md items-center gap-3' key={index}>
            <div className='w-[88px] h-[88px] md:min-w-[108px] md:min-h-[108px] bg-white/10  rounded-xl flex justify-center items-center'>
              <Image src={Element.image ||`/images/revenue${index+1}.svg`} alt='revenue1' height={55} width={57} className=' w-[47] h-[45px] md:w-[57px] md:h-[55]' />
            </div>
            <div className=' leading-[29px]'>
              <p className=' text-[22px] md:text-[28px] lg:text-[38px] xl:text-[44px] font-bold'>{Element?.title}</p>
              <p className=' mt-3 font-medium text-[16px] md:text-[18px] lg:text-[20px]'>{Element?.description}</p>
            </div>
          </div>
          )}
        </div>
        <div className='w-full mt-8 flex flex-wrap justify-center lg:justify-start gap-3  items-center'>
          {
            <Link href= {props?.link_url1||'/get-a-free-quote/'}>
                            <button className="text-white text-[18px] gap-3 flex items-center border-[2px] rounded-full p-[2px]  border-lightpink 
                        font-medium  group  transition-all duration-300">
                                <div className="w-[45px] h-[45px] flex bg-white/10 justify-center items-center rounded-full
                        border-lightpink border-[1px] transform transition-transform duration-300  group-hover:rotate-45 group-hover:translate-x-2">
                                    <GoArrowUpRight className="-rotate-30 group-hover:text-white text-[28px] text-white" />
                                </div>
                                <span className="transform mr-4 transition-transform  duration-300 group-hover:translate-x-2">
                                    <p >{props?.link_text1||"Get A Quote Now"}</p>
                                </span>
                        </button>
        </Link>            
                        }
        <ClientsCount/>
        </div>
      </div>
    </div>
  )
}

export default Revenue